/**
 * Socket
 *
 * Please read https://socket.io/how-to/use-with-react
 */
import { io } from "socket.io-client";

// "undefined" means the URL will be computed from the `window.location` object
// const URL:string = process.env.NODE_ENV === 'production' ? undefined : 'http://localhost:4000';

// const URL: string =
//   process.env.NODE_ENV === "production"
//     ? `http://${window.location.hostname}:8080`
//     : "http://localhost:8080";

const URL: string =
  process.env.NODE_ENV === "production"
    ? "https://game-uno-server-365992732645.europe-southwest1.run.app"
    : "http://localhost:8080";

export const socket = io(URL, {
  autoConnect: false,
});
